import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { type OfferV11 } from '@redteclab/api/clients/bully'

import { useGetExperiment } from '../../../../../../experiments/hooks'
import { EXPERIMENT_NAME_MARKETPLACE_HARMONISATION } from '../../../../../../experiments/model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from '../../../../../../experiments/model/EXPERIMENT_VARIATION'
import { useGlobalConfigContext } from '../../../../../../global-config'
import { productAccessorGetSellerPromotionFromOffer } from '../../../../../model/productAccessor/productAccessorGetSellerPromotionFromOffer'
import { ProductHeadGenericLabel } from '../../ProductHeadGenericLabel/ProductHeadGenericLabel'

type ProductHeadSellerPromotionLabelProps = {
  className?: string
  offer: OfferV11 | undefined
}

export const ProductHeadSellerPromotionLabel: FC<
  ProductHeadSellerPromotionLabelProps
> = ({ className, offer }) => {
  const { superScripts } = useGlobalConfigContext()
  const marketplaceHarmonisationExperiment = useGetExperiment(
    EXPERIMENT_NAME_MARKETPLACE_HARMONISATION,
  )

  if (!offer) {
    return null
  }

  const sellerPromotion = productAccessorGetSellerPromotionFromOffer(offer)

  if (!sellerPromotion) {
    return null
  }

  return (
    <ProductHeadGenericLabel
      className={clsx(
        'border-light-primary-medium',
        marketplaceHarmonisationExperiment.variant === EXPERIMENT_VARIATION.V1
          ? 'bg-light-tertiary'
          : 'bg-light-redpoints',
        className,
      )}
      data-qa-id="product-label-seller-promotion"
    >
      {sellerPromotion.conditionType === 'minimumSameItemQuantity' &&
      sellerPromotion.discountType === 'freeItems' ? (
        <FormattedMessage
          id="seller.promotion.product.badge.freeItems"
          values={{
            payableItemCount:
              sellerPromotion.conditionValue - sellerPromotion.discountValue,
            sup: superScripts.sellerPromotions ? (
              <sup>{superScripts.sellerPromotions}</sup>
            ) : null,
            targetItemCount: sellerPromotion.conditionValue,
          }}
        />
      ) : (
        <FormattedMessage id="seller.promotion.product.badge.discount" />
      )}
    </ProductHeadGenericLabel>
  )
}
